import Model from "../Model";

class GroupZonesComercial extends Model{

    buildUrl ({ param }) {
        return ['commercialview/getzonesbyuserid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new GroupZonesComercial;